import { FC, forwardRef } from 'react';
import { spacing } from 'ui/theme';
import {
  StyledSkeletonContainer,
  PanelWrapper,
  PanelHeader,
  PanelContent,
  GreyPanelWrapper,
} from './Styled';

type PanelProps = {
  children: React.ReactNode;
  testId: string;
  title: string;
  panelActions?: JSX.Element;
  height: string | number;
  loading: boolean;
};

type PanelBodyProps = Omit<PanelProps, 'testId'> & {
  padding: string;
};

const PanelBody: FC<PanelBodyProps> = ({
  title,
  panelActions = <></>,
  height,
  loading,
  padding,
  children,
}) => {
  return (
    <>
      <PanelHeader padding={padding}>
        <span>{title}</span>
        {panelActions}
      </PanelHeader>
      <StyledSkeletonContainer isLoading={loading} height={loading ? height : 'auto'}>
        {!loading && <PanelContent>{children}</PanelContent>}
      </StyledSkeletonContainer>
    </>
  );
};

export const Panel: FC<PanelProps> = ({ testId, ...props }) => {
  return (
    <PanelWrapper data-test={testId}>
      <PanelBody {...props} padding={`0 0 ${spacing.plusHalf} 0`} />
    </PanelWrapper>
  );
};

export const GreyPanel = forwardRef<HTMLDivElement, PanelProps & { borderColor?: string }>(
  ({ testId, borderColor = 'transparent', ...props }, ref) => {
    return (
      <GreyPanelWrapper ref={ref} data-test={testId} borderColor={borderColor}>
        <PanelBody {...props} padding={`${spacing.plusHalf} ${spacing.plusHalf} ${spacing.base}`} />
      </GreyPanelWrapper>
    );
  },
);
